module.exports = __webpack_public_path__ + "static/media/sex-ON.106c5a54.png";